import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ReactTable from "react-table";
import QueryString from 'query-string';
import i18next from 'i18next';
import { AccessHelper, BaseTable } from '../../helpers';
import { RowButton } from '../RowButton';
import { Message } from '../Message';
import { RolesService } from '../../services';

class RoleList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      localErrorMessage: null
    };
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
        <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  render() {
    return (
        <div className="clearfix role-list-wrapper">
          {this.renderMessages()}

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-block">

                    <RoleTable
                      roleType={this.props.roleType}
                      roleTypes={this.props.roleTypes}
                      selectedRoleType={this.props.selectedRoleType}
                      currLocation={this.props.currLocation}
                      currSearch={this.props.currSearch}
                      pushHistory={this.props.pushHistory}
                      localErrorHandler={this.handleLocalError.bind(this)}
                    />

                  </div>
                </div>
              </div>
            </div>

        </div>
    );
  }
}


@connect(state => {
  return {
    me: state.user.me
  }
})
class RoleTable extends React.Component {

  constructor(props) {
    super(props);

    const passedState = this.props.currLocation ? this.props.currLocation.state : null;

    this.DEFAULT_SORTED = [{ id: 'name', desc: false }];

    this.fetchData = this.fetchData.bind(this);
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);
    this.updateRequestURL = this.updateRequestURL.bind(this);
    this.getForcePage = this.getForcePage.bind(this);

    this.state = {
      linkTo: null,
      backLinkSearch: null,
      localErrorHandler: this.props.localErrorHandler,
      data: [],
      pageCount: null,
      forcePage: null,
      loading: true,
      totalElements: null,
      parsedOptions: QueryString.parse(this.props.currSearch),
      currentHistoryCount: passedState && passedState.currentHistoryCount ? passedState.currentHistoryCount : 0,
      viewAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/admin/roles/view/:roleId'),
      editAllowed: AccessHelper.userHasAccess(this.props.me.availableRoutes, '/admin/roles/edit/:roleId'),
    };
  }

  viewLinkClick(rowId) {
    this.setState({
      linkTo: `/admin/roles/view/${rowId}`,
      backLinkSearch: this.props.currLocation.search
    });
  }

  editLinkClick(rowId) {
    this.setState({
      linkTo: `/admin/roles/edit/${rowId}`,
      backLinkSearch: this.props.currLocation.search
    });
  }

  datafetched(res) {
    let page = this.refs.rolesTable.state.page;
    this.setState({
      data: res.data,
      pageCount: res.pageCount,
      forcePage: res.forcePage,
      page: page,
      loading: false,
      totalElements: res.recordsTotal
    });
  }

  fetchData(tableData, instance) {
    if (this.updateRequestURL(tableData)) {
      return;
    }

    this.setState({
      loading: true
    });

    this.makeDatatableRequest(tableData, this.datafetched, null);
  }

  makeDatatableRequest (data, callback, settings) {
    let apiOptions = this.state.parsedOptions;
    delete apiOptions['selectedRoleType'];

    let options = BaseTable.buildFetchDataOptions(apiOptions, this.DEFAULT_SORTED);

    RolesService.getAllByRoleType(this.props.roleType.id, options).then(response => {
      const pageCount = Math.ceil(response.page.totalElements / this.refs.rolesTable.state.pageSize);
      let forcePage = this.getForcePage(pageCount);
      callback({
        data: response.roles,
        pageCount: pageCount,
        forcePage: forcePage,
        recordsTotal: response.page.totalElements
      });
    }).catch(error => {
      console.error(error);
      this.state.localErrorHandler(error.message);
    });
  }

  updateRequestURL(tableData) {
    let options = tableData ? BaseTable.buildURLOptions(tableData, this.DEFAULT_SORTED) : [];
    if (this.props.selectedRoleType) {
      options.push({ 'selectedRoleType': this.props.selectedRoleType.token });
    }

    let params = options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');

    const currentSearch = this.props.currSearch ? this.props.currSearch : '?';

    if (`?${params}` !== currentSearch) {
      if (this.state.currentHistoryCount > 100) {
        console.error('Exceeded the history count stack of 100.');
        return false;
      }
      this.props.pushHistory({
        search: `?${params}`,
        state: {
          currentHistoryCount: this.state.currentHistoryCount + 1,
          selectedRoleType: this.props.selectedRoleType,
          roleTypes: this.props.roleTypes
        }
      });
      return true;
    } else {
      return false;
    }
  }

  getForcePage(pageCount) {
    let forcePage = null;
    if (this.refs.rolesTable && this.refs.rolesTable.state
      && this.refs.rolesTable.state.page >= pageCount) {
      forcePage = pageCount - 1;
    }
    return forcePage;
  }

  render() {
    const { data, pageCount, loading, totalElements } = this.state;

    if (this.state.linkTo) {
      return <Redirect push to={{ pathname: this.state.linkTo, roleType: this.props.roleType, state: { backLinkSearch: this.state.backLinkSearch }}} />;
    }

    let dynamicOptions = BaseTable.buildDynamicOptions(this.state.parsedOptions, this.state.forcePage, this.DEFAULT_SORTED);

    return (
      <div className="react-table-custom">
        <ReactTable
          className="-striped -highlight"
          ref="rolesTable"
          manual // Forces table not to paginate or sort automatically, so we can handle it server-side
          data={data}
          pages={pageCount} // Display the total number of pages
          loading={loading} // Display the loading overlay when we need it
          onFetchData={this.fetchData} // Request new data when things change
          totalElements={totalElements}
          showPaginationTop
          columns={[
                      {
                        Header: i18next.t('table-headers.name'),
                        accessor: "name",
                        sortable: true,
                        minResizeWidth: 50
                      },
                      {
                        Header: i18next.t('table-headers.description'),
                        accessor: "description",
                        sortable: true,
                        minResizeWidth: 50
                      },
                      {
                        Cell: cell => <RowButton 
                                        allowView = {this.state.viewAllowed}
                                        allowEdit = {this.state.editAllowed}
                                        editClick = {this.editLinkClick.bind(this)} 
                                        viewClick = {this.viewLinkClick.bind(this)} 
                                        rowId={cell.original.id}/>,
                        sortable: false,
                        width: 150
                      }
                    ]}
          {...dynamicOptions}
        />
      </div>
    )
  }
}

export default RoleList;
